"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateGamepad = exports.getInput = exports.InputState = void 0;
var logger_1 = require("../../../engine/logger");
var common_sidecar_1 = require("../../../main/common-sidecar");
var rogueCursor_sidecar_1 = require("../ui/rogueCursor-sidecar");
var rogueInput_sidecar_1 = require("./rogueInput-sidecar");
var rogueRunMode_sidecar_1 = require("./rogueRunMode-sidecar");
var logger = (0, logger_1.createLogger)('rogueGamepad');
var InputState;
(function (InputState) {
    InputState[InputState["JustUp"] = 0] = "JustUp";
    InputState[InputState["JustDown"] = 1] = "JustDown";
    InputState[InputState["StaleUp"] = 2] = "StaleUp";
    InputState[InputState["StaleDown"] = 3] = "StaleDown";
})(InputState = exports.InputState || (exports.InputState = {}));
var _input = null;
var getInput = function () {
    if (!_input) {
        _input = {
            left: InputState.StaleUp,
            right: InputState.StaleUp,
            up: InputState.StaleUp,
            down: InputState.StaleUp,
            a: InputState.StaleUp,
            b: InputState.StaleUp,
            x: InputState.StaleUp,
            y: InputState.StaleUp,
            bumperLeft: InputState.StaleUp,
            bumperRight: InputState.StaleUp,
        };
    }
    return _input;
};
exports.getInput = getInput;
var updateGamepad = function () {
    var s = common_sidecar_1.common.getPhaserScene();
    var phaserInput = s.input;
    if (phaserInput.gamepad.total === 0) {
        return;
    }
    var debug = [];
    var pads = phaserInput.gamepad.gamepads;
    var _loop_1 = function () {
        pad = pads[i];
        if (!pad) {
            return "continue";
        }
        //  Timestamp, index. ID
        debug.push(pad.id);
        debug.push('Index: ' + pad.index + ' Timestamp: ' + pad.timestamp);
        var updateKey = function (buttonIdx, name) {
            var curState = (0, exports.getInput)()[name];
            var isPressed = false;
            if (pad.buttons[buttonIdx] && pad.buttons[buttonIdx].value > 0.5) {
                isPressed = true;
            }
            var nextState = InputState.StaleUp;
            if (isPressed) {
                if (curState !== InputState.JustDown &&
                    curState !== InputState.StaleDown) {
                    logger.log('pressed', name);
                    nextState = InputState.JustDown;
                }
                else {
                    nextState = InputState.StaleDown;
                }
            }
            else {
                if (curState !== InputState.JustUp && curState !== InputState.StaleUp) {
                    nextState = InputState.JustUp;
                }
                else {
                    nextState = InputState.StaleUp;
                }
            }
            (0, exports.getInput)()[name] = nextState;
        };
        updateKey(12, 'up');
        updateKey(13, 'down');
        updateKey(14, 'left');
        updateKey(15, 'right');
        updateKey(0, 'a');
        updateKey(1, 'b');
        updateKey(2, 'x');
        updateKey(3, 'y');
        updateKey(4, 'bumperLeft');
        updateKey(5, 'bumperRight');
        var input = (0, exports.getInput)();
        var processMove = function (key, move) {
            if (input[key] === InputState.JustDown) {
                rogueCursor_sidecar_1.rogueCursor.setInputGamepad();
                rogueInput_sidecar_1.rogueInput.setNextInputCommandAndRun(move);
            }
            if (input[key] === InputState.JustUp) {
                rogueCursor_sidecar_1.rogueCursor.setInputGamepad();
                rogueRunMode_sidecar_1.rogueRunMode.cancelRunMode();
            }
        };
        processMove('up', rogueInput_sidecar_1.rogueInput.EInputCommand.moveUp);
        processMove('down', rogueInput_sidecar_1.rogueInput.EInputCommand.moveDown);
        processMove('left', rogueInput_sidecar_1.rogueInput.EInputCommand.moveLeft);
        processMove('right', rogueInput_sidecar_1.rogueInput.EInputCommand.moveRight);
        processMove('bumperLeft', rogueInput_sidecar_1.rogueInput.EInputCommand.moveWait);
        if (input.bumperLeft === InputState.JustDown) {
            rogueCursor_sidecar_1.rogueCursor.setInputGamepad();
            rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_sidecar_1.rogueInput.EInputCommand.openInventory);
        }
        if (input.bumperRight === InputState.JustDown) {
            rogueCursor_sidecar_1.rogueCursor.setInputGamepad();
            rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_sidecar_1.rogueInput.EInputCommand.openCastMenu);
        }
        if (input.a === InputState.JustDown) {
            rogueCursor_sidecar_1.rogueCursor.setInputGamepad();
            rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_sidecar_1.rogueInput.EInputCommand.select);
        }
        if (input.b === InputState.JustDown) {
            rogueCursor_sidecar_1.rogueCursor.setInputGamepad();
            rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_sidecar_1.rogueInput.EInputCommand.cancel);
        }
        if (input.y === InputState.JustDown) {
            rogueCursor_sidecar_1.rogueCursor.setInputGamepad();
            rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_sidecar_1.rogueInput.EInputCommand.openCastMenu);
        }
        if (input.x === InputState.JustDown) {
            rogueCursor_sidecar_1.rogueCursor.setInputGamepad();
            rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_sidecar_1.rogueInput.EInputCommand.openContextMenu);
        }
        //  Buttons
        // var buttons = ''
        for (var b = 0; b < pad.buttons.length; b++) {
            button = pad.buttons[b];
            if (button.value > 0.01) {
                logger.log('button', b, button.value);
            }
            // if (b === 12) {
            //   rogueInput.setNextInputCommand(rogueInput.EInputCommand.moveUp)
            // }
            // if (b === 13) {
            //   rogueInput.setNextInputCommand(rogueInput.EInputCommand.moveDown)
            // }
            // if (b === 14) {
            //   rogueInput.setNextInputCommand(rogueInput.EInputCommand.moveLeft)
            // }
            // if (b === 15) {
            //   rogueInput.setNextInputCommand(rogueInput.EInputCommand.moveRight)
            // }
            // if (b === 0) {
            //   rogueInput.setNextInputCommand(rogueInput.EInputCommand.select)
            // }
            // if (b === 1) {
            //   rogueInput.setNextInputCommand(rogueInput.EInputCommand.closeMenu)
            // }
            // if (b === 3) {
            //   rogueInput.setNextInputCommand(
            //     rogueInput.EInputCommand.openRogueInventory,
            //   )
            // }
            // buttons = buttons.concat('B' + button.index + ': ' + button.value + '  ')
            // // buttons = buttons.concat('B' + b + ': ' + button.value + '  ');
            // if (b === 8) {
            //   debug.push(buttons)
            //   buttons = ''
            // }
        }
    };
    var pad, button;
    for (var i = 0; i < pads.length; i++) {
        _loop_1();
    }
};
exports.updateGamepad = updateGamepad;
